import { DisabilitySeverity } from './disability-severity.app';

export interface DisabilityStatus {
	id: number;
	remark: string;
	relatedDisabilitySeverities?: DisabilitySeverity[];
	initial: DisabilityStatusInitial | string;
}

export enum DisabilityStatusInitial {
	// Schwerbehindertenausweis
	SEVERELY_DISABLED = 'KBS01',

	// Von der Agentur für Arbeit gleichgestellt nach § 2, Abs. 3 SGB IX
	EQUALIZED = 'KBS02',

	// Anerkennung / Gleichstellung beantragt
	APPLICATION_PENDING = 'KBS03',

	// Behindert nach § 2, Abs. 1 SGB IX
	DISABLED = 'KBS04',

	// Gleichstellung für Berufsorientierung (und -ausbildung) nach § 151 Abs. 4 SGB IX
	EQUALIZATION_FOR_TRAINING = 'KBS06',

	// Sonstiges
	OTHER = 'KBS99',
}
